export class ResetCustom {
	static handleUpdatePasswordFormSubmit() {
		$('#m_update_password_submit').click((e) => {
			let btn = $(e.target);
			let form = $(e.target).closest('form');
			form.validate({
				rules: {
					password: {
						required: true
					},
					confirm: {
						required: true,
						equalTo: 'input[name=password]'
					}
				}
			});
			if (!form.valid()) {
				e.preventDefault();
				return;
			}
		});
	}
	static handleUpdatePinFormSubmit() {
		$('#m_update_pin_submit').click((e) => {
			let btn = $(e.target);
			let form = $(e.target).closest('form');
			form.validate({
				rules: {
					pin: {
						required: true,
						digits: true,
						minlength: 4,
						maxlength: 4
					},
					confirm: {
						required: true,
						equalTo: 'input[name=pin]'
					}
				}
			});
			if (!form.valid()) {
				e.preventDefault();
				return;
			}
		});
	}

	static init() {
		ResetCustom.handleUpdatePasswordFormSubmit();
		ResetCustom.handleUpdatePinFormSubmit();
	}
}